import ModB from "./ModB";
import {Col, Row, Card} from "react-bootstrap";
import Document from "../document/document";
import Button from "react-bootstrap/Button";
import {FileEarmarkMedicalFill, FileEarmarkPlus, Tags} from 'react-bootstrap-icons'
import './ModRecent.scss'
import DocumentModal from "../document/DocumentModal";
import {useState} from "react";
import {useNavigate, Link} from "react-router-dom";

const ModRecent = () => {
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const handleManageTypes = () => navigate('/doc/type');
    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);
    const handleManageDocuments = () => navigate('/documents');
    return (<>
            <ModB className="mod-recent" title="Documents">
                <Row className="mod-recent-header">
                    <Col className="mod-recent-header-list">
                        <Card>
                            <Card.Body>
                                <Card.Title>Recent</Card.Title>
                                <Document path="../Personal" title="Pasport" expDate={new Date()}></Document>
                                <Document path="../Medical" title="Blood pressure" expDate={new Date()}></Document>
                                <Document path="../Tickets" title="IMAX Lord of the ri..." expDate={new Date()}></Document>
                                <Link to="/documents/list">View all</Link>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col className="mod-recent-header-buttons">
                        <Button size={"lg"} onClick={handleShowModal}><FileEarmarkPlus size={30}/> Add Document</Button>
                        <Button size={"lg"} onClick={handleManageTypes}><Tags size={30}/> Manage doc types</Button>
                        <Button size={"lg"} onClick={handleManageDocuments}><FileEarmarkMedicalFill size={30}/> Manage documents</Button>
                    </Col>
                </Row>
            </ModB>
            <DocumentModal show={showModal} onHide={handleCloseModal} />
        </>
    );
}

export default ModRecent;